<template>
  <div class="pb-3" >
    <va-card :title="$t(`rss.cards.${titleCard}`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required" name="URL" v-slot="{ errors }">
                <va-input
                  v-model="rss.url"
                  :label="$t('rss.forms.urlLabel')"
                  :placeholder="$t('rss.forms.urlPlaceholder')"
                  :success="errors.length == 0 && rss.url.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <div class="form-group mt-3 mb-3">
                <va-select
                  :label="$t('rss.forms.userLabel')"
                  v-model="user"
                  textBy="name"
                  keyBy='id'
                  no-clear
                  searchable
                  :placeholder="$t('rss.forms.userPlaceholder')"
                  :noOptionsText="$t('rss.forms.userNoOption')"
                  maxHeight='200px'
                  :options="users.length > 0 ? users : []"
                />
              </div>
              <div class="form-group mt-3 mb-3">
                <va-select
                  :label="$t('rss.forms.clubLabel')"
                  v-model="club"
                  textBy="name"
                  keyBy='id'
                  no-clear
                  searchable
                  :placeholder="$t('rss.forms.clubPlaceholder')"
                  :noOptionsText="$t('rss.forms.clubNoOption')"
                  maxHeight='200px'
                  :options="clubs.length > 0 ? clubs : []"
                />
              </div>
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
                <va-button
                  type="button"
                  class="my-0"
                  color="danger"
                  @click="cancel">
                  {{ $t("forms.cancel") }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
export default {
  name: 'RSSAddUpdate',
  props: {
    page: {
      type: Number,
      required: true,
    },
    titleCard: {
      type: String,
      required: true,
    },
    updateData: {
      required: true,
    },
  },
  data () {
    return {
      rss: {
        url: '',
        userId: '',
        clubId: '',
      },
      user: '',
      club: '',
      users: [],
      clubs: [],
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  created () {
    this.rss.url = ''
    this.rss.userId = ''
    this.rss.clubId = ''
    if (this.updateData !== null) {
      this.rss_get(this.updateData)
    }
  },
  watch: {
    updateData (_) {
      if (this.updateData !== null) {
        this.rss_get(this.updateData)
      } else {
        this.rss.url = ''
        this.rss.userId = ''
        this.rss.clubId = ''
      }
    },
    user (value) {
      if (value !== '') {
        this.rss.userId = value.id
      }
    },
    club (value) {
      if (value !== '') {
        this.rss.clubId = value.id
      }
    },
  },
  apollo: {
    clubs: {
      query: gql`
      query myquery {
        clubs: club(order_by: {name: asc}, where: {id: {_neq: 1}}) {
          id
          name
        }
      }
      `,
      result ({ data, loading }) {
        if (!loading) {
          if (data.clubs.length > 0 && this.club === '') {
            this.club = Object.assign({}, data.clubs[0])
          }
        }
      },
    },
    users: {
      query: gql`
      query myquery {
        users: user(order_by: {id: asc}) {
          id
          name
        }
      }
      `,
      result ({ data, loading }) {
        if (!loading) {
          if (data.users.length > 0 && this.user === '') {
            this.user = Object.assign({}, data.users[0])
          }
        }
      },
    },
  },
  methods: {
    cancel () {
      this.$emit('showAdd', false)
    },
    rss_get (data) {
      Object.keys(data).forEach((value, key) => {
        if (value !== '__typename') {
          if (value === 'user') {
            this.user = data[value]
          } else if (value === 'club') {
            this.club = data[value]
          } else {
            this.rss[value] = data[value]
          }
        }
      })
    },
    onSubmit () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      const { url, userId, clubId } = this.rss
      const self = this
      this.$apollo
        .mutate({
          mutation: (this.updateData !== null ? gql`
                mutation MyMutation($url: String!, $user_id: Int!, $club_id: Int!, $id: Int!) {
                  update_source_rss_by_pk(pk_columns: {id: $id}, _set: {url: $url, user_id: $user_id, club_id: $club_id}) {
                    id
                  }
                }
                ` : gql`
                mutation MyMutation($url: String!, $user_id: Int!, $club_id: Int!) {
                  insert_source_rss(objects: {url: $url, user_id: $user_id, club_id: $club_id}) {
                    affected_rows
                  }
                }
                `
          ),
          variables: this.updateData !== null ? {
            url: url,
            user_id: userId,
            club_id: clubId,
            id: this.rss.id,
          } : {
            url: url,
            user_id: userId,
            club_id: clubId,
          },
        })
        .then(data => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.rss.url = ''
          self.rss.userId = ''
          self.rss.clubId = ''
          self.$emit('showAdd', false)
          self.$emit('showMore', self.page)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.successUpdate' : 'toasts.successCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.rss.url = ''
          self.rss.userId = ''
          self.rss.clubId = ''
          self.$emit('showAdd', false)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.errorUpdate' : 'toasts.errorCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style lang="scss">
.va-message-list {
  &__message {
    vertical-align: middle;
    font-size: $font-size-mini;
    color: rgb(248, 112, 109);
  }
}

.position {
  position: relative;
}
</style>
